<script setup lang="ts">
import {useCachedMainNavigation} from "~/components/server/useCachedMainNavigation";

const route = useRoute();
const to = route.query.to as string;
const params = { to: to };

defineOptions({
  name: "AccountLayout",
});

useAuthGuardRedirection(params);

// Navigation for Account page
const { logout } = useUser();
const router = useRouter();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const { data } = useAsyncData("mainNavigation", () => {
  return useCachedMainNavigation (3, "main-navigation");
});
provide("swNavigation-main-navigation", data);

const { data: footerData } = useAsyncData("mainFooterNavigation", () => {
  return useCachedMainNavigation (1, "footer-navigation");
});
provide("swNavigation-footer-navigation", footerData);

async function invokeLogout() {
  logout();
  router.push("/");
}

const { user } = useUser();

const sections = [
  { path: "/account", title: "plubel.account.overview" },
  { path: "/account/profile", title: "account.yourProfile" },
  { path: "/account/address", title: "account.yourAddress" },
  // TODO - commented as per client requirement - enable when payments are enabled
  // { path: "/account/payment", title: "account.myPaymentsHeader" },
  { path: "/account/order", title: "account.orderHistoryHeader" },
];
const { locale } = useI18n();
const isActiveRoute = (path: string) => {
  const localePrefix = `/${locale.value}`;
  return (
    router.currentRoute.value.path === localePrefix + path ||
    router.currentRoute.value.path === path
  );
};
</script>

<template>
  <div>
    <LayoutHeader />
    <LayoutNotifications />
    <div class="container">
      <LayoutBreadcrumbs />
    </div>

    <section class="pb-20 md:pb-28 lg:pb-40 xl:pb-52">
      <div class="container">
        <div class="flex flex-wrap md:flex-nowrap flex-start w-full md:pt-20">
          <div class="w-full md:w-[230px] lg:w-[260px] md:pt-20 lg:pt-36">
            <h5
              class="mb-10 md:px-2 text-2xl font-redit_sans_con font-extrabold"
            >
              {{ $t("plubel.account.hello") }}, <br />
              {{ user.firstName }}
            </h5>
            <ul
              style="border-top: solid 1px #7ea081"
              class="font-redit_sans_con block mb-10 lg:mb-0"
            >
              <li
                v-for="section in sections"
                :key="section.path"
                class="border-solid border-cust_green border-b"
              >
                <NuxtLink
                  class="block py-4 px-2"
                  :to="formatLink(section.path)"
                  :class="{ 'text-cust_green': isActiveRoute(section.path) }"
                >
                  {{ $t(section.title) }}
                </NuxtLink>
              </li>

              <li class="border-solid border-cust_green border-b">
                <button class="block py-4 px-2" @click="invokeLogout()">
                  {{ $t("account.logout") }}
                </button>
              </li>
            </ul>
          </div>
          <slot />
        </div>
      </div>
    </section>
    <LayoutFooter />
  </div>
</template>
